import {
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@material-ui/core";
import { format, parseISO } from "date-fns";
import { forwardRef, useEffect, useState } from "react";
import { handleAxiosError } from "../../../../common/data/axiosErrorHandler";
import {
  DriverSpeedingEventDetailsDto,
  SafetyDashboardApiFactory,
} from "../../../../common/data/service-proxies";
import { useAxiosInstance } from "../../../../common/hooks/useAxiosInstance";
import {
  useButtonStyles,
  useTableHeaderStyles,
} from "../../../assets/maintenance-dashboard/common";
import { Empty } from "../../../assets/maintenance-dashboard/widgets/Empty";
import { Widget } from "../../../assets/maintenance-dashboard/widgets/Widget";
import { DriverWidgetProps } from "../common";
import { Button } from "react-admin";
import { useHistory } from "react-router-dom";
import resourceNames from "../../../../common/data/resourceNames";
import { AssignmentInd } from "@material-ui/icons";

export const DriverSpeedingEvents = forwardRef(
  ({ className, icon, title, driver, ...rest }: DriverWidgetProps, ref) => {
    const [loading, setLoading] = useState<boolean>(true);
    const [data, setData] = useState<DriverSpeedingEventDetailsDto[]>();
    const axios = useAxiosInstance();
    const classes = useTableHeaderStyles();
    const buttonClasses = useButtonStyles();
    const history = useHistory();

    useEffect(() => {
      if (!axios) {
        setLoading(false);
        return;
      }

      if (!driver?.id) {
        setLoading(false);
        return;
      }

      setLoading(true);
      SafetyDashboardApiFactory(undefined, axios.defaults.baseURL, axios)
        .apiAppSafetydashboardIdSpeedingeventsfordriverGet(driver.id)
        .then((result) => {
          setData(result.data);
        })
        .catch((e) => console.error(handleAxiosError(e)))
        .finally(() => setLoading(false));
    }, [axios, driver]);

    const hasDifferentDriver = data?.some(
      (x) =>
        !!x.currentVehicleDriverId && x.currentVehicleDriverId !== driver.id
    );

    return (
      <Widget
        title={title}
        icon={icon}
        className={className}
        ref={ref}
        {...rest}>
        <div className="categories">
          {loading ? (
            <div className="category">
              <CircularProgress size="3rem" />
            </div>
          ) : data && data.length ? (
            <div className="table-wrapper">
              <TableContainer>
                <Table size="small">
                  <TableHead>
                    <TableRow className={classes.tableHead}>
                      <TableCell>Time</TableCell>
                      <TableCell>Location</TableCell>
                      <TableCell>Speed</TableCell>
                      <TableCell colSpan={2}>
                        {hasDifferentDriver
                          ? "Vehicle (currently driven by)"
                          : "Vehicle"}
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {data?.map((x) => (
                      <TableRow key={x.id}>
                        <TableCell>
                          {format(
                            parseISO(x.timestamp!),
                            "MMM do, yyyy hh:mm:ss a"
                          )}
                        </TableCell>
                        <TableCell>{x.geolocation}</TableCell>
                        <TableCell>{x.drivingSpeed} mph</TableCell>
                        <TableCell>{x.vehicleName}</TableCell>
                        {!!x.currentVehicleDriverId &&
                        x.currentVehicleDriverId !== driver.id ? (
                          <TableCell>
                            <Button
                              label={`${x.currentVehicleDriverFullName!} (${
                                x.currentVehicleDriverAssignedId
                              })`}
                              className={buttonClasses.label}
                              onClick={() =>
                                history.push(
                                  `/${resourceNames.SAFETY_DASHBOARD}/${x.currentVehicleDriverId}`
                                )
                              }>
                              <AssignmentInd />
                            </Button>
                          </TableCell>
                        ) : null}
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
          ) : (
            <Empty />
          )}
        </div>
      </Widget>
    );
  }
);
